import { useEffect, useState } from 'react';
import {
  Box, Typography, TextField, Button, Stack,
  FormControl, InputLabel, Select, MenuItem,
} from '@mui/material';
import intl from 'components/i18n/ReactIntlWrapper';
import ResizableDrawer from 'components/Layout/ResizableDrawer';

interface Props {
  open: boolean;
  onClose: () => void;
  onSave: (data: any) => Promise<void>;
  item: any;
  roles: any[];
  seniorities: any[];
}

const ProfileDrawer: React.FC<Props> = ({ open, onClose, onSave, item, roles, seniorities }) => {
  const [idRole, setIdRole] = useState<number | ''>('');
  const [idSeniority, setIdSeniority] = useState<number | ''>('');
  const [description, setDescription] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setIdRole(item?.idRole ?? item?.role?.id ?? '');
    setIdSeniority(item?.idSeniority ?? item?.seniority?.id ?? '');
    setDescription(item?.description ?? '');
  }, [item, open]);

  const handleSave = async () => {
    if (!idRole || !idSeniority) return;
    setSaving(true);
    try {
      await onSave({ idRole: Number(idRole), idSeniority: Number(idSeniority), description: description.trim() || null });
    } finally {
      setSaving(false);
    }
  };

  return (
    <ResizableDrawer open={open} onClose={onClose} defaultWidth={440}>
      <Typography variant="h6" sx={{ mb: 3 }}>
        {item ? intl.get('hr.profile.edit') : intl.get('hr.profile.add')}
      </Typography>
      <Box component="form" onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
        <FormControl fullWidth required sx={{ mb: 2 }}>
          <InputLabel>{intl.get('hr.profile.role')}</InputLabel>
          <Select value={idRole} onChange={(e) => setIdRole(e.target.value as number)} label={intl.get('hr.profile.role')}>
            {roles.map((r) => <MenuItem key={r.id} value={r.id}>{intl.get(r.label) || r.label}</MenuItem>)}
          </Select>
        </FormControl>
        <FormControl fullWidth required sx={{ mb: 2 }}>
          <InputLabel>{intl.get('hr.profile.seniority')}</InputLabel>
          <Select value={idSeniority} onChange={(e) => setIdSeniority(e.target.value as number)} label={intl.get('hr.profile.seniority')}>
            {seniorities.map((s) => <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>)}
          </Select>
        </FormControl>
        <TextField
          label={intl.get('hr.profile.description')}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          fullWidth multiline rows={3} sx={{ mb: 3 }}
        />
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button onClick={onClose}>{intl.get('common.cancel')}</Button>
          <Button type="submit" variant="contained" disabled={saving}>{intl.get('common.save')}</Button>
        </Stack>
      </Box>
    </ResizableDrawer>
  );
};

export default ProfileDrawer;
